"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentType = exports.DocumentTypes = void 0;
var DocumentTypes;
(function (DocumentTypes) {
    DocumentTypes["SALES"] = "sales";
    DocumentTypes["SHIPPING"] = "shipping";
})(DocumentTypes = exports.DocumentTypes || (exports.DocumentTypes = {}));
const getDocumentType = (type) => {
    if (type.toLowerCase() === DocumentTypes.SHIPPING)
        return DocumentTypes.SHIPPING;
    else
        return DocumentTypes.SALES;
};
exports.getDocumentType = getDocumentType;
//# sourceMappingURL=documentTypes.js.map